var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"pa-3",attrs:{"color":"primary","dark":"","app":""}},[_c('span',[_vm._v(" © 2019 - "),_c('strong',[_vm._v("Thinxtra")])])])}
var staticRenderFns = []

export { render, staticRenderFns }